{
  "bulkOnboarding": {
    "departments": {
      "title": "Osztályok létrehozása",
      "description": "Töltsön fel egy Excel fájlt a szervezet osztálystruktúrájával. Az osztályok ideiglenesen tárolódnak, amíg a menedzserek hozzárendelése meg nem történik a következő lépésekben.",
      "uploadTitle": "Osztályok feltöltése Excelből",
      "toast": {
        "createSuccess": "Osztályok sikeresen létrehozva!",
        "createFailed": "Nem sikerült az osztályok létrehozása",
        "validationRequired": "Kérjük, először töltse fel az osztályokat",
        "fixErrors": "Kérjük, javítsa az érvényesítési hibákat a beküldés előtt"
      }
    },
    "users": {
      "title": "Munkatársak létrehozása",
      "description": "Töltsön fel egy Excel fájlt a szervezet munkatársival. A munkatársak létrehozásakor az egyező menedzser e-mail címmel rendelkező osztályokhoz automatikusan hozzárendelődik a menedzser. A fennmaradó osztályokat a következő lépésben manuálisan kell feloldani.",
      "uploadTitle": "Munkatársak feltöltése Excelből",
      "toast": {
        "createSuccess": "Munkatársak sikeresen létrehozva! Az egyező menedzser e-mail címmel rendelkező osztályokhoz automatikusan hozzárendelődött a menedzser.",
        "createFailed": "Nem sikerült a munkatársak létrehozása",
        "validationRequired": "Kérjük, először töltse fel a munkatársakat",
        "fixErrors": "Kérjük, javítsa az érvényesítési hibákat a beküldés előtt"
      }
    },
    "processes": {
      "uploadTitle": "Folyamatok feltöltése Excelből",
      "toast": {
        "createSuccess": "Folyamatok sikeresen létrehozva! A folyamattulajdonosok automatikusan hozzárendelődtek az osztályvezetők alapján.",
        "createFailed": "Nem sikerült a folyamatok létrehozása",
        "fixErrors": "Kérjük, javítsa az érvényesítési hibákat a beküldés előtt"
      }
    },
    "resolution": {
      "description": "Néhány esetben a vezetői e-mailt nem tudjuk egyértelműen egy munkatárshoz kapcsolni. Ellenőrizze az eredményeket.",
      "loading": "Ideiglenes osztályok betöltése...",
      "instructions": "Válasszon menedzsert minden osztályhoz az ideiglenes állapotból az élesbe való átálláshoz.",
      "table": {
        "name": "Név",
        "abbreviation": "Rövidítés",
        "managerEmail": "Keresett e-mail",
        "managerFound": "Menedzser megtalálva és feloldásra kész",
        "alreadyResolved": "Már feloldva",
        "noDescription": "Nincs leírás",
        "assignManager": "Hozzárendelt vezető"
      },
      "toast": {
        "batchSuccess": "{{count}} osztály sikeresen feloldva",
        "partialSuccess": "{{success}} osztály feloldva. {{failed}} sikertelen.",
        "batchFailed": "Nem sikerült az osztályok feloldása",
        "unresolvedDepartments": "Kérjük, oldja fel az összes osztályt a beállítás befejezése előtt. Minden osztályhoz menedzsert kell rendelni."
      },
      "success": {
        "title": "Összes osztály feloldva!",
        "description": "Minden osztályhoz sikeresen hozzárendelődött a menedzser."
      }
    },
    "assignManager": {
      "selectPlaceholder": "Válasszon munkatársat…"
    },
    "validation": {
      "nameRequired": "A név megadása kötelező",
      "abbreviationRequired": "A rövidítés megadása kötelező",
      "descriptionRequired": "A leírás megadása kötelező",
      "invalidEmail": "Érvénytelen e-mail cím",
      "firstNameRequired": "A keresztnév megadása kötelező",
      "lastNameRequired": "A vezetéknév megadása kötelező",
      "departmentRequired": "Az osztály megadása kötelező",
      "roleRequired": "A pozíció megadása kötelező",
      "ownerEmailInvalid": "Érvényes e-mail-cím szükséges",
      "orgFunctionNameRequired": "A funkció / csapat megadása kötelező",
      "licenceSeatsInvalid": "A licencek számának 0 vagy annál nagyobb egész számnak kell lennie",
      "unknownMemberEmail": "A(z) {{email}} nem tartozik egyik munkatárshoz sem",
      "duplicateEntry": "Ismétlődő bejegyzés",
      "circularParent": "Egy osztály nem lehet saját maga fölérendeltje – közvetve sem",
      "existingMember": "Már létezik – ez a tag már szerepel a szervezetben, és itt nem szerkeszthető",
      "roleDescriptionConflict": "Azonos pozíció, eltérő leírások – egy pozícióhoz pontosan egy leírás tartozik",
      "accountableEmailInvalid": "érvénytelen e-mail-cím",
      "accountableEmailNotFound": "a(z) {{email}} e-mail-cím nem tartozik egyik taghoz sem"
    },
    "excel": {
      "sheets": {
        "instructions": "Utasítások",
        "departments": "Osztályok",
        "users": "Munkatársak",
        "processes": "Folyamatok",
        "functions": "Funkciók",
        "teams": "Csapatok",
        "memberships": "Tagságok",
        "systems": "Rendszerek",
        "dataSyncPeople": "Munkatársak"
      },
      "columns": {
        "departments": {
          "name": "Név*",
          "abbreviation": "Rövidítés*",
          "description": "Leírás",
          "parentAbbreviation": "Szülő rövidítés",
          "managerEmail": "Menedzser e-mail"
        },
        "users": {
          "firstName": "Keresztnév*",
          "lastName": "Vezetéknév*",
          "email": "E-mail*",
          "department": "Osztály*",
          "role": "Pozíció*",
          "roleDescription": "Pozíció leírása"
        },
        "processes": {
          "name": "Név*",
          "description": "Leírás*",
          "department": "Osztály*",
          "ownerEmail": "Folyamatfelelős e-mail*",
          "accountableEmail": "Felelős e-mail (opcionális)"
        },
        "functions": {
          "name": "Név*",
          "description": "Leírás",
          "department": "Osztály",
          "leadEmail": "Vezető e-mail",
          "email": "Közös postafiók e-mail"
        },
        "teams": {
          "name": "Név*",
          "description": "Leírás",
          "department": "Osztály",
          "leadEmail": "Vezető e-mail",
          "email": "Közös postafiók e-mail"
        },
        "memberships": {
          "orgFunctionName": "Funkció / Csapat*",
          "memberEmail": "Tag e-mail*"
        },
        "systems": {
          "name": "Név*",
          "description": "Leírás",
          "category": "Kategória",
          "url": "URL",
          "licenceSeats": "Licencek száma",
          "ownerEmail": "Rendszerfelelős e-mail*"
        },
        "dataSync": {
          "id": "ID",
          "parentDepartment": "Szülő osztály",
          "lead": "Vezető e-mail",
          "owner": "Rendszerfelelős e-mail",
          "location": "Telephely"
        }
      }
    }
  },
  "welcomePage": {
    "welcome": "Üdvözöljük",
    "checkTask": "Ellenőrizze feladatait",
    "minimizeVolume": "Minimális erőfeszítés Önnek, maximális haszon mindenkinek",
    "minimizeVolumeDesc": "Rögzítse és optimalizálja folyamatait minimális erőfeszítéssel és maximális hatékonysággal.",
    "allResourceInOne": "Minden folyamat-erőforrás egy helyen",
    "allResourceInOneDesc": "Kezelje az összes folyamatrelevans erőforrást központilag és hatékonyan.",
    "completeProcess": "Teljes folyamatáttekintés - Könnyen érthető",
    "completeProcessDesc": "Tartsa szemmel az összes folyamatot intuitív BPMN-ábrázolásunkkal.",
    "howRecordingWork": "Hogyan működik a virális folyamatrögzítés?",
    "continueToDashboard": "Tovább az áttekintéshez"
  },
  "initialSetup": {
    "title": "Kezdeti beállítás",
    "wizardHeading": "BLIKS IO beállítási varázsló",
    "topBar": {
      "logoAlt": "BLIKS IO logó"
    },
    "pending": {
      "title": "A kezdeti beállítás még nem fejeződött be",
      "description": "A szervezet beállítása még nem fejeződött be teljesen. Először a szervezet egy szervezeti menedzserének be kell fejeznie a kezdeti beállítást – amint ez megtörtént, azonnal elkezdheti a munkát. Az oldal automatikusan frissül."
    },
    "removalBlocked": {
      "department": {
        "processes": "Az osztály nem törölhető: {{count}} folyamat hivatkozik rá. Először rendelje a folyamatokat másik osztályhoz a Folyamatok lépésben."
      },
      "user": {
        "systems": "A munkatárs nem törölhető: {{count}} rendszer felelőseként szerepel. Először rendelje a rendszereket másik személyhez a Rendszerek lépésben.",
        "processes": "A munkatárs nem törölhető: {{count}} folyamat felelőseként vagy létrehozójaként szerepel. Először rendelje a folyamatokat másik személyhez a Folyamatok lépésben."
      },
      "orgFunction": {
        "mainRole": "A funkció nem törölhető: {{count}} munkatárs fő funkciója. Először módosítsa a munkakörüket a Munkatársak lépésben."
      }
    },
    "completeBlocked": {
      "title": "Az első beállítás még nem fejezhető be:",
      "unresolvedDepartments": "{{count}} osztálynak nincs hozzárendelt vezetője.",
      "goToResolve": "Vezetők hozzárendelése",
      "usersWithoutDepartment": "{{count}} munkatársnak nincs osztálya.",
      "goToUsers": "Ugrás a Munkatársak lépéshez"
    },
    "steps": {
      "welcome": "Üdvözöljük",
      "departments": "Osztályok",
      "employees": "Munkatársak",
      "resolveManagers": "Vezetők hozzárendelése",
      "functions": "Funkciók",
      "teams": "Csapatok",
      "systems": "Rendszerek",
      "processes": "Folyamatok",
      "overview": "Áttekintés & befejezés"
    },
    "stepDescriptions": {
      "departments": "Szervezetének váza",
      "employees": "Személyek, mindegyik egy munkakörhöz rendelve",
      "resolveManagers": "A vezetőket a hozzáadott munkatársak közül kapcsoljuk össze",
      "functions": "A munkatársak további funkciói",
      "teams": "Csapatok, amelyekben a munkatársak együtt dolgoznak",
      "systems": "A használt szoftverrendszerek",
      "processes": "Lista a későbbi virális felméréshez",
      "overview": "Szervezeti ábra előnézete és megerősítés"
    },
    "footer": {
      "next": "Tovább",
      "skip": "Kihagyás",
      "finish": "Befejezés",
      "start": "Kezdjük"
    },
    "autosave": {
      "pending": "Nem mentett módosítások",
      "saving": "Mentés…",
      "saved": "Automatikusan mentve",
      "error": "Az automatikus mentés sikertelen — a „Tovább” gomb újra megpróbálja"
    },
    "welcome": {
      "title": "Üdvözöljük a BLIKS IO-ban",
      "intro": "Mielőtt a BLIKS IO bevezetésre kerül a szervezetében, néhány lépésben közösen felépítjük szervezete teljes képét. Ne aggódjon: a beállítás során senki sem kap értesítést — az itt létrehozott személyek sem.",
      "checklist": {
        "title": "Amit érdemes előkészítenie",
        "departments": "Szervezeti osztályai és azok hierarchiája",
        "people": "Szervezete összes munkatársa",
        "systems": "A használatban lévő rendszerek",
        "processes": "A később rögzítendő folyamatok"
      },
      "pauseResume": "Ezek az információk többnyire központilag megtalálhatók az Önök HCM- és EAM-szoftverében. Hiányzik valami? Nem gond — bármikor szüneteltethet, és pontosan ott folytathatja, ahol abbahagyta."
    },
    "outcomes": {
      "title": "Ezt kapja a végén",
      "description": "Az első beállítás után a BLIKS IO készen áll arra, hogy szervezete egészében bevezessék. A négy építőelemből három egyértelmű eredmény születik.",
      "cards": {
        "structure": {
          "title": "Szervezeti felépítés",
          "body": "Osztályok, pozíciók, valamint csapatok & kiegészítő funkciók. Az organigram automatikusan létrejön a kapcsolatokból."
        },
        "systems": {
          "title": "Rendszeráttekintés",
          "body": "A szervezetében használt összes rendszer — a katalógus-metaadatokkal együtt."
        },
        "processes": {
          "title": "Folyamatáttekintés",
          "body": "A rögzíteni kívánt folyamatok — hogy valójában hogyan futnak, azt a BLIKS IO később a virális rögzítés révén tartja nyilván."
        }
      },
      "hint": "<bold>Két dolog előre:</bold> Nem baj, ha az első beállításban még nem minden teljes — később bármikor manuálisan pontosíthat. Szeretné szervezetét automatikusan felépíteni és naprakészen tartani? Keressen minket: a BLIKS IO-t közvetlenül összekötjük az Önök HCM- és EAM-szoftverével."
    },
    "doneNotice": {
      "departments": {
        "title": "Az osztályok már be vannak állítva",
        "description": "Az importálás befejeződött. A <bold>Tovább</bold> közvetlenül menti a meglévő sorok módosításait és az új sorokat. Egy sor eltávolítása törli az importált bejegyzést, és kiüríti a rá mutató hivatkozásokat – az így keletkező hiányokat a befejezés előtt pótolni kell. Az osztályok menedzserét is itt módosíthatja a Menedzser e-mail oszlopban."
      },
      "users": {
        "title": "A munkatársak már be vannak állítva",
        "description": "Az importálás befejeződött. A <bold>Tovább</bold> közvetlenül menti a meglévő sorok módosításait és az új sorokat. Egy sor eltávolítása törli az importált bejegyzést, és kiüríti a rá mutató hivatkozásokat – az így keletkező hiányokat a befejezés előtt pótolni kell."
      },
      "optional": {
        "title": "Ez a lépés már megtörtént",
        "description": "Bármikor hozzáadhat további bejegyzéseket – a meglévők változatlanok maradnak."
      }
    },
    "resolve": {
      "counters": {
        "open": "Nyitott",
        "resolved": "Már megoldva"
      },
      "suggestion": "Javaslat: {{name}}",
      "applySuggestion": "Átvétel"
    },
    "functionsTeams": {
      "autoCreatedBanner": "{{count}} funkció már létrejött a munkatársak pozíciómegnevezéseiből.",
      "functionsSection": {
        "title": "Funkciók",
        "stepTitle": "Funkciók létrehozása",
        "description": "A munkatársak gyakran nem személyként, hanem funkciójukban járnak el — pl. „Adatvédelmi tisztviselő” vagy „Product owner”. Hozza létre őket itt, vagy töltse fel Excelből.",
        "hint": "Ha az adatok éppen nem állnak rendelkezésre, kihagyhatja ezt a lépést — a funkciók bármikor kiegészíthetők."
      },
      "teamsSection": {
        "title": "Csapatok",
        "stepTitle": "Csapatok létrehozása",
        "description": "Együtt dolgozó csoportok — pl. „Első szintű támogatási csapat”. Hozzon létre csapatokat, majd rendeljen hozzájuk tagokat.",
        "hint": "Opcionális — a csapatok bármikor kiegészíthetők, akár a folyamatrögzítés közben is."
      },
      "columns": {
        "lead": "Vezetés",
        "sharedMailbox": "Megosztott postafiók",
        "member": "Munkatárs",
        "function": "Funkció",
        "team": "Csapat"
      },
      "membershipsTable": {
        "heading": "Tagságok"
      },
      "mailImportNote": "Excel-importnál a vezetés egy személy e-mail-címe alapján kerül hozzárendelésre. A nem talált e-maileket pirossal jelöljük, és manuálisan kell személyhez rendelni. A csapatokat a következő lépésben hozza létre.",
      "toast": {
        "fixErrors": "Kérjük, először javítsa a feltöltött sorok hibáit",
        "createSuccess": "{{created}} bejegyzés létrehozva, {{linked}} tagság összekapcsolva",
        "createFailed": "Az import nem sikerült"
      },
      "mainRoleLockedRemove": "Ez a funkció pozícióként van hozzárendelve, ezért nem törölhető – először módosítsa az érintett munkatársak pozícióját."
    },
    "systems": {
      "title": "Rendszerek rögzítése",
      "description": "Milyen szoftvereket használ szervezete? Rögzítsen minden rendszert a legfontosabb adatokkal — vagy töltsön fel egy meglévő rendszerlistát Excelből.",
      "toast": {
        "fixErrors": "Kérjük, először javítsa a feltöltött sorok hibáit",
        "createSuccess": "Rendszerek elmentve",
        "createFailed": "A rendszerek létrehozása nem sikerült"
      }
    },
    "processes": {
      "title": "Folyamatok rögzítése",
      "description": "Mely folyamatokat rögzítse a BLIKS IO? Itt csak a fő listát adja meg — a részleteket később a munkatársak szolgáltatják.",
      "hint": "Bármikor hozzáadhat további folyamatokat — vagy teljesen kihagyhatja ezt a lépést.",
      "mailImportNote": "A felelősök személyhez rendelve kerülnek megadásra. Excel-importnál a hozzárendelés az e-mail alapján történik — a nem talált e-maileket pirossal, „Felhasználó nem található” jelöléssel látjuk el.",
      "ownerEmail": "Folyamatfelelős (e-mail)"
    },
    "columns": {
      "systems": {
        "name": "Rendszernév",
        "licenceSeats": "Licencek",
        "owner": "Felelős"
      },
      "processes": {
        "owner": "Folyamatfelelős",
        "accountable": "Felelős"
      }
    },
    "columnHints": {
      "departments": {
        "name": "Az osztály teljes neve",
        "abbreviation": "Rövid és egyedi, pl. \"FC\"",
        "description": "Miért felelős az osztály?",
        "parentAbbr": "Üres = legfelső szint",
        "managerEmail": "A vezető személy e-mail-címe"
      },
      "users": {
        "firstName": "pl. \"Patrick\"",
        "lastName": "pl. \"Lenz\"",
        "email": "Munkahelyi, egyedinek kell lennie",
        "department": "Az osztály, ahol a személy dolgozik",
        "role": "A munkakör, pl. \"Head of Controlling\"",
        "roleDescription": "A munkakör feladatai és súlypontjai"
      },
      "functions": {
        "name": "pl. \"Adatvédelmi tisztviselő\"",
        "description": "Feladatok és felelősségi körök",
        "department": "Üres, ha keresztfunkcionális",
        "lead": "A vezetés e-mail-címe",
        "sharedMailbox": "Megosztott postafiók, pl. support@…"
      },
      "memberships": {
        "member": "A funkciót ellátó személy",
        "target": "A személy funkciója vagy csapata"
      },
      "systems": {
        "name": "A rendszer vagy a szolgáltató neve",
        "category": "pl. CRM, ERP, HR-eszköz",
        "url": "A szolgáltató weboldala",
        "licenceSeats": "Elérhető licencek, ha korlátozottak",
        "owner": "A rendszerért felelős személy"
      },
      "processes": {
        "name": "pl. \"Új ügyfél felvétele\"",
        "description": "Mit nyújt a folyamat? Kezdete és vége",
        "department": "Az osztály, amelyhez a folyamat tartozik",
        "owner": "Felelős a dokumentáció karbantartásáért",
        "accountable": "Opcionális — alapértelmezés szerint az osztályvezető"
      }
    },
    "fieldExplainer": {
      "required": "Kötelező",
      "optional": "Opcionális",
      "headings": {
        "departments": "Ezekre az információkra van szükségünk osztályonként",
        "users": "Ezekre az információkra van szükségünk személyenként",
        "functionsTeams": "Ezekre az információkra van szükségünk – két területre bontva",
        "systems": "Ezekre az információkra van szükségünk rendszerenként",
        "processes": "Ezekre az információkra van szükségünk folyamatonként"
      },
      "sections": {
        "entity": "1. Funkció vagy csapat",
        "memberships": "2. Tagságok"
      },
      "fields": {
        "departments": {
          "name": "Az osztály teljes neve, pl. „Controlling & Reporting”",
          "abbreviation": "Rövid, egyedi rövidítés, pl. „FC”. Horgonyként szolgál az osztályok összekapcsolásához.",
          "description": "Miért felelős az osztály? pl. „Tervezés, költségvetés, riportálás”. A leírás pontossága befolyásolhatja az MI-alapú elemzések eredményeit. A leírást később bármikor bővítheti.",
          "parentAbbr": "A fölérendelt osztály rövidítése – csak a legfelső szinten hagyja üresen. Ebből automatikusan felépül az organogramja.",
          "managerEmail": "Az osztályt vezető személy e-mail-címe. A 2. lépésben automatikusan összekapcsolódik, amint a személy munkatársként létezik."
        },
        "users": {
          "firstName": "A személy keresztneve, pl. „Patrick”",
          "lastName": "A személy vezetékneve, pl. „Lenz”",
          "email": "A személy céges e-mail-címe. Egyedinek kell lennie. Az 1. lépés vezetői e-mail-címeivel egyeztetjük és automatikusan összekapcsoljuk.",
          "department": "Annak az osztálynak a rövidítése, ahol a személy dolgozik – az 1. lépés listájából. Elhelyezi a személyt és az állást az organogramban.",
          "role": "Mire alkalmazták a személyt? pl. „Head of Controlling”, „Könyvelési ügyintéző”. Ez az állás.",
          "roleDescription": "Miért felelős ez az állás? Feladatok, felelősségi körök, fókuszterületek. A későbbi elemzések alapja – minél pontosabb, annál jobbak az eredmények."
        },
        "functions": {
          "name": "A funkció egyedi neve, pl. „Adatvédelmi tisztviselő”, vagy a csapaté, pl. „First Level Support Team”",
          "description": "Feladatok és felelősségi körök. A későbbi elemzések alapja.",
          "department": "Az olyan, funkciókon átívelő szerepeknél, mint a „Product Owner”, hagyja üresen. Csak akkor töltse ki, ha a funkciók vagy csapatok egyértelműen egy osztályhoz tartoznak.",
          "lead": "A funkciót vagy csapatot vezető személy e-mail-címe. Gyakran csak a csapatoknak (pl. „First Level Support Team”) van vezetője.",
          "sharedMailbox": "A funkció vagy csapat közös, megosztott postafiókja, pl. „support@…”"
        },
        "memberships": {
          "member": "Egy személy e-mail-címe a 2. lépésből. Egy személy tetszőleges számú funkcióban és csapatban tevékenykedhet.",
          "target": "A fenti területen szereplő funkció vagy csapat neve. Összekapcsolja a személyeket a funkciókkal."
        },
        "systems": {
          "name": "Mi a rendszer vagy a rendszer szolgáltatójának neve? Ha a rendszert a szervezetében külön néven ismerik, nyugodtan használja a vállalaton belüli szóhasználatot.",
          "description": "Írja le a rendszer képességeit. Mire használják Önöknél?",
          "category": "Milyen típusú rendszerről van szó? pl. „CRM”, „ERP”, „HR-eszköz”",
          "url": "Milyen URL-en érhető el a rendszer szolgáltatója?",
          "licenceSeats": "Egyes rendszereikhez csak korlátozott számú licenc áll rendelkezésre. Ha van korlát, itt feljegyezheti a darabszámot. Elemezzük, hogy a napi működés során mennyire használják ki a licenchelyeket.",
          "owner": "Annak a személynek az e-mail-címe, aki a vállalatnál a rendszerért felelős, és a legjobban le tudja írni, mi és hogyan történik a rendszerben."
        },
        "processes": {
          "name": "Egyértelmű megnevezés, pl. „Új ügyfél felvétele”, „Értékesítési folyamat” vagy hasonló.",
          "description": "Mit nyújt ez a folyamat? Mivel kezdődik, mivel végződik? Ez a leírás a későbbi elemzések és a munkatársak általi felvétel alapja – minél pontosabb, annál jobb.",
          "department": "Az 1. lépésben megadott osztály rövidítése, amelyhez a folyamat tartozik.",
          "owner": "Annak a személynek az e-mail-címe, aki ezért a folyamatért a BLIKS IO-ban felel. Fontos: ez kizárólag azt a felelősséget jelenti, hogy a folyamat a BLIKS IO-ban dokumentálva és naprakészen legyen tartva – nem a vállalaton belüli tartalmi vagy eredményfelelős szerepet. Ha ez a szerep Önöknél nincs egyértelműen meghatározva, válassza azt a személyt, akinél a dokumentáció gondozása a legjobb helyen van.",
          "accountable": "A folyamatért felelős személy e-mail-címe (RACI értelemben). Opcionális: ha üresen marad, az osztály jelenlegi vezetője jelenik meg felelősként — az osztályvezető későbbi változásait ilyenkor automatikusan követi."
        }
      }
    },
    "overview": {
      "title": "Gratulálunk",
      "subtitle": "Szervezete immár rögzítve van a BLIKS IO-ban.",
      "description": "Felépítette a vázat. A többit — ki mit csinál valójában, hogyan futnak a folyamatok ténylegesen, milyen árnyékrendszerek vannak használatban — mostantól a munkatársak automatikusan hozzáadják a rögzítés során.",
      "cards": {
        "departments": "Osztályok",
        "members": "Munkatársak & pozíciók",
        "functions": "Funkciók",
        "teams": "Csapatok",
        "systems": "Rendszerek",
        "processes": "Folyamatok",
        "departmentLevels": "{{count}} szinten",
        "distinctPositions": "{{count}} pozíciómegnevezés",
        "fromPositions": "ebből {{count}} pozíciókból",
        "readyForRecording": "rögzítésre kész"
      },
      "organigram": {
        "title": "Az Ön organogramja",
        "description": "Automatikusan felépítve az osztálykapcsolatokból.",
        "fullscreen": "Teljes képernyős nézet"
      },
      "toast": {
        "completed": "A kezdeti beállítás befejeződött!",
        "completeFailed": "A befejezés nem sikerült",
        "pendingChanges": "Vannak még nem alkalmazott módosítások. Kérjük, erősítse meg az érintett lépést a „Tovább” gombbal, mielőtt befejezi a beállítást."
      },
      "invite": {
        "checkboxLabel": "Meghívó küldése mind a(z) {{count}} tagnak most",
        "helper": "A tagok e-mailt kapnak a fiókjuk aktiválásához és jelszó beállításához.",
        "success": "{{count}} meghívó elküldve",
        "skipped": "{{count}} tag kihagyva"
      }
    },
    "upload": {
      "errorBanner": "Kérjük, javítsa a táblázatban jelölt hibákat.",
      "invalidRowsCount": "{{count}} sor érvényesítési hibával"
    },
    "uploadFromExcel": "Excel importálása",
    "personio": {
      "load": "Betöltés a Personióból",
      "loaded": "Betöltve a Personióból.",
      "unlinkDescription": "A hozzáférési adatok törlődnek; a már betöltött sorok megmaradnak."
    },
    "tables": {
      "departments": "Osztályok",
      "users": "Munkatársak",
      "systems": "Rendszerek",
      "processes": "Folyamatok"
    },
    "draftTable": {
      "removeRow": "Sor eltávolítása",
      "noSelection": "– nincs kiválasztva –",
      "userNotFound": "Felhasználó nem található"
    },
    "existingEntities": {
      "title": "Már létezik ({{count}})",
      "editableNote": "Ezek a tagok már léteznek – a név és az e-mail zárolt. Itt rendelheti hozzájuk az osztályt és a pozíciót."
    },
    "protectedRows": {
      "lockedIdentity": "Ennek a tagnak a nevét és e-mail-címét a meglévő fiókja kezeli, itt nem módosíthatók.",
      "placementFailed": "A meglévő tagok osztály-hozzárendelésének mentése nem sikerült."
    },
    "addRow": {
      "department": "Osztály hozzáadása",
      "employee": "Munkatárs hozzáadása",
      "orgFunction": "Funkció hozzáadása",
      "team": "Csapat hozzáadása",
      "membership": "Tagság hozzáadása",
      "system": "Rendszer hozzáadása",
      "process": "Folyamat hozzáadása"
    },
    "clearDrafts": "Lista törlése",
    "clearConfirm": {
      "title": "Kiüríti a listát?",
      "description": "A táblázat összes sora törlődik. Ez a művelet nem vonható vissza.",
      "deleteAllDescription": "Minden sor eltávolításra kerül. A már importált bejegyzések a folytatáskor véglegesen törlődnek.",
      "confirm": "Kiürítés"
    },
    "pendingDeleteAll": "A lista kiürítésre került: minden importált bejegyzés véglegesen törlődik, ha a „Tovább” gombbal folytatja.",
    "doneBadge": "Befejezve",
    "usersImport": {
      "membersNotLoaded": "A taglista még nem töltődött be – kérjük, próbálja újra."
    }
  }
}
